import {RequestStatusEnum} from './requestStatusEnum';

export class ConsentModel {

  company: string;
  casenumber: string;
  caseCreatedDate: string;
  language: string;
  uuid: string;
  consentStatus: RequestStatusEnum;
  acceptedDate: string;
  doctorUUID: string;

  constructor() {
  }

  public clearData() {
    this.company = '';
    this.casenumber = '';
    this.caseCreatedDate = '';
    this.language = '';
    this.uuid = '';
    this.consentStatus = null;
    this.doctorUUID = '';
    this.acceptedDate = '';
  }
}
